import { XCircle, RefreshCw, ArrowLeft } from "lucide-react";
import { useLocation } from "wouter";

export default function PaymentFailed() {
  const [, navigate] = useLocation();

  return (
    <div className="flex h-full min-h-[60vh] items-center justify-center p-6">
      <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-xl ring-1 ring-gray-900/5">
        <div className="bg-red-50 px-8 py-12 text-center sm:px-10">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-red-100 ring-8 ring-red-50">
            <XCircle className="h-10 w-10 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-gray-900">Payment Failed</h2>
          <p className="mt-3 text-base text-gray-600 leading-relaxed">
            We couldn't process your payment. Your subscription was not updated. Please try again or use a different payment method.
          </p>
        </div>
        <div className="bg-gray-50 px-8 py-8 flex flex-col gap-3 border-t border-gray-100">
          <button
            onClick={() => navigate("/settings/payment-billing")}
            className="group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-red-600 px-5 py-3.5 text-sm font-semibold text-white shadow-md transition-all hover:bg-red-700 active:scale-[0.98]"
          >
            <RefreshCw className="h-4 w-4" />
            Retry Payment
          </button>
          
          <button
            onClick={() => navigate("/")}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-white px-5 py-3.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all hover:bg-gray-50 active:scale-[0.98]"
          >
            <ArrowLeft className="h-4 w-4 text-gray-500" />
            Return to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
